import { useState } from "react";
import { Building2, Check, ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLayout } from "./context";

export function HeaderTitleDefault() {
  const t = useTranslations("layout30.organizationSelector");
  const [open, setOpen] = useState(false);
  const { settings } = useLayout();
  const organization = settings.identity?.organization ?? t("current");

  return (
    <div
      data-slot="organization-header-title"
      data-debug-source="components/layouts/layout-30/components/header-title-default.tsx"
      className="group flex min-w-0 items-center"
    >
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            aria-label={t("label")}
            className="-ms-1 min-w-0 max-w-[min(12rem,36vw)] justify-between gap-1 px-2 text-zinc-100 hover:bg-zinc-800 hover:text-white data-[state=open]:bg-zinc-800 data-[state=open]:text-white"
          >
            <span className="min-w-0 truncate text-sm font-semibold">
              {organization}
            </span>
            {open ? (
              <ChevronsDownUp className="size-4 shrink-0 text-zinc-400" />
            ) : (
              <ChevronsUpDown className="size-4 shrink-0 text-zinc-400" />
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[min(20rem,calc(100vw-1rem))] text-sm"
          side="bottom"
          align="start"
          sideOffset={7}
        >
          <DropdownMenuLabel>{t("menuLabel")}</DropdownMenuLabel>
          <DropdownMenuGroup>
            <DropdownMenuItem
              disabled
              className="flex min-w-0 items-start justify-between gap-2 data-disabled:opacity-100"
            >
              <span className="min-w-0 whitespace-normal [overflow-wrap:anywhere]">
                {organization}
              </span>
              <Check
                className="mt-0.5 size-4 shrink-0 text-primary"
                aria-hidden="true"
              />
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem disabled>
            <Building2 className="size-4" />
            <span>{t("managementUnavailable")}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
